// extracted by mini-css-extract-plugin
export default {"layout_container":"Layout_layout_container__tdg4H","content":"Layout_content__QWkJl","login_content":"Layout_login_content__ipNhr"};